import { useCallback } from "react"

import { useUrlParams } from "../utils/useUrlParams"

import { useNavigate } from "./useNavigate"

export function useNavigateWithSearchParams() {

    const { getParams } = useUrlParams()
    const navigate = useNavigate()
    const searchParams = getParams()
    const existingSearchParams = Array.from(searchParams.entries()).some(([_, paramValue]) => paramValue.length)

    const navigateWithSearchParams = useCallback((url, options = {}) => {
        const {
            paramsToDelete,
            ...otherOptions
        } = options
        const urlContainingParams = url.indexOf("?") >= 0
        if (paramsToDelete?.length) {
            paramsToDelete.forEach(paramToDelete => {
                searchParams.delete(paramToDelete)
            })
        }
        navigate(existingSearchParams ? `${url}${urlContainingParams ? "&" : "?"}${searchParams}` : url, otherOptions)
    }, [existingSearchParams, searchParams, navigate])

    return navigateWithSearchParams
}